import React from 'react'
import {Modal, FormControl, FormGroup, ControlLabel} from 'react-bootstrap'
import Button from '../../components/Button'

const defaultTitle = "ChineSpain的建议"
const defaultTitleSpanish = "Sugerencia de ChineSpain"

class NewNotificationModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      title: defaultTitle,
      msg: "hola",
      type: "msg", // "msg", "post", "url"
      url: "www.chinespain.cn"
    }
  }

  render() {
    return (
      <Modal show onHide={() => this.props.onCancel()}>
        <Modal.Header>
          <Modal.Title>
            Notificación inmediata
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {/* ******** */}

          <FormGroup>
            <ControlLabel>Título <small>(Sólo visible en la app, no en la notificación)</small></ControlLabel>
            <FormControl
              value={this.state.title}
              onChange={evt => this.setState({ title: evt.target.value })}
            />
            {
              this.state.title == defaultTitle && (
                <span style={{fontStyle: "italic"}}>"{defaultTitleSpanish}"</span>
              )
            }
          </FormGroup>

          <FormGroup>
            <ControlLabel>Tipo</ControlLabel>
            <FormControl
              componentClass="select"
              placeholder="msg"
              value={this.state.type}
              onChange={evt => this.setState({ type: evt.target.value })}
            >
              <option value="msg">Mensaje</option>
              <option value="post">Llevar a un post (dentro de la app)</option>
              <option value="url">Llevar a una web (url)</option>
            </FormControl>
          </FormGroup>

          <FormGroup>
            <ControlLabel>Mensaje</ControlLabel>
            <FormControl
              value={this.state.msg}
              onChange={evt => this.setState({ msg: evt.target.value })}
            />
          </FormGroup>

          {
            (this.state.type == "post" || this.state.type == "url") && (
              <FormGroup>
                <ControlLabel>URL</ControlLabel>
                <FormControl
                  value={this.state.url}
                  onChange={evt => this.setState({ url: evt.target.value })}
                />
              </FormGroup>
            )
          }

          <code>
            {
              JSON.stringify(this.state)
            }
          </code>

          {/* ******** */}

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.props.onCancel()}>Cancelar</Button>
          <Button onClick={() => this.props.onSend(this.state)}>Enviar</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default NewNotificationModal
